import { render, staticRenderFns } from "./OrganizationMembershipStatusCard.vue?vue&type=template&id=2c62d71f&scoped=true"
import script from "./OrganizationMembershipStatusCard.vue?vue&type=script&lang=js"
export * from "./OrganizationMembershipStatusCard.vue?vue&type=script&lang=js"
import style0 from "./OrganizationMembershipStatusCard.vue?vue&type=style&index=0&id=2c62d71f&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c62d71f",
  null
  
)

export default component.exports